module.exports = __webpack_public_path__ + "pattern6.88ab8ad95a8055d0f3dc.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/pattern6.png
// module id = ../../../../../src/assets/images/pattern6.png
// module chunks = styles